import * as type from "../types";

const initialState = {
    users: [],
    userCars: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
    case type.SET_USERS_LIST:
        return {
            ...state,
            users: action.value
        };
    case type.ADD_USER:
        return {
            ...state,
            users: [...state.users, action.value]
        };
    case type.DELETE_USER:
        return {
            ...state,
            users: state.users.filter(user => user.uzytkownik_id !== action.value)
        };
    case type.SET_USER_CARS:
        return {
            ...state,
            userCars: action.value
        };
    case type.UPDATE_USER:
        return {
            ...state,
            users: state.users.map(user => {
                if(user.uzytkownik_id === action.id)
                    return {...user, ...action.value};
                return user;
            })
        };
    default:
        return state;
    }
};
